module.exports = __webpack_public_path__ + "static/mobile-inauthentic-engagement-f4a70de514168f16147be06ac0312f2b.gif";